import { Button, KIND as ButtonKind } from 'baseui/button'
import { Input } from 'baseui/input'
import SDPaginator from '@/shared/components/SDComponents/SDPaginator/SDPaginator'
import { Table } from 'baseui/table-semantic'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import { Spinner } from 'baseui/spinner'
import useClientCallbacksPage from './useClientCallbacksPage.jsx'
import {
  ViewButtonsRow,
  SearchActions,
  TableWrapper,
  LoadingOverlay,
  FooterRow,
  ResultsCount,
  ModalBodyContent,
} from './styled-components.js'
import { Card, Header1 } from '@/shared/theme/styled-components.js'

const views = [
  { id: 'upcoming', i18n: 'filters.upcoming' },
  { id: 'last', i18n: 'filters.last' },
  { id: 'deleted', i18n: 'filters.deleted' },
]

const ClientCallbacksPage = () => {
  const {
    t,
    loading,
    pagination,
    confirmDeleteId,
    searchTerm,
    columns,
    data,
    setSearchTerm,
    triggerSearch,
    refresh,
    changePage,
    changeView,
    confirmDelete,
    closeDelete,
  } = useClientCallbacksPage()

  return (
    <Card>
      <Header1>{t('menu:clientCallbacks')}</Header1>
      <ViewButtonsRow>
        {views.map(view => (
          <Button
            key={view.id}
            onClick={() => changeView(view.id)}
            kind={view === view.id ? ButtonKind.primary : ButtonKind.secondary}
            size='compact'
          >
            {t(`clientCallbacks:${view.i18n}`)}
          </Button>
        ))}
        <SearchActions>
          <Input
            size='compact'
            clearable
            value={searchTerm}
            placeholder={t('clientCallbacks:search_placeholder')}
            onChange={e => setSearchTerm(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') triggerSearch()
            }}
          />
          <Button size='compact' onClick={triggerSearch}>
            {t('clientCallbacks:search_button')}
          </Button>
          <Button size='compact' kind={ButtonKind.secondary} isLoading={loading} onClick={refresh}>
            {t('clientCallbacks:refresh')}
          </Button>
        </SearchActions>
      </ViewButtonsRow>
      <TableWrapper>
        <Table columns={columns} data={data} />
        {loading && (
          <LoadingOverlay>
            <Spinner size='2rem' />
          </LoadingOverlay>
        )}
      </TableWrapper>
      <FooterRow>
        <ResultsCount>
          {t('clientCallbacks:results_count', {
            total: pagination.total,
            current: pagination.currentPage,
            last: pagination.lastPage,
          })}
        </ResultsCount>
        <SDPaginator
          numPages={pagination.lastPage}
          currentPage={pagination.currentPage}
          onPageChange={({ nextPage }) => changePage(nextPage)}
          overrides={{ NextButton: { props: { disabled: pagination.currentPage >= pagination.lastPage } } }}
        />
      </FooterRow>

      <Modal onClose={closeDelete} isOpen={!!confirmDeleteId} closeable={false}>
        <ModalHeader>{t('clientCallbacks:delete_modal.title')}</ModalHeader>
        <ModalBody>
          <ModalBodyContent>
            <p>{t('clientCallbacks:delete_modal.line1')}</p>
            <p>{t('clientCallbacks:delete_modal.line2')}</p>
            <p>{t('clientCallbacks:delete_modal.line3')}</p>
          </ModalBodyContent>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind='tertiary' onClick={closeDelete}>
            {t('clientCallbacks:delete_modal.cancel')}
          </ModalButton>
          <ModalButton onClick={confirmDelete} kind='primary'>
            {t('clientCallbacks:delete_modal.confirm')}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </Card>
  )
}

export default ClientCallbacksPage
